import { EditSkillDevelopment } from './edit-skill-development.component';

export default EditSkillDevelopment;
